import React from 'react';
import { Box } from '@mui/material';
import TicketsTable from '../../../../../components/TicketsTable';
import { getLocationId } from '../../../utils/locationTransformers';

const TicketsTab = ({ selectedLocation }) => {
  const locationId = getLocationId(selectedLocation);

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <TicketsTable
        locationId={locationId}
        locationData={selectedLocation}
        onViewTicket={(ticket) => {
          const ticketId = ticket.id || ticket._id;
          window.location.href = `/tickets?selectedId=${ticketId}`;
        }}
      />
    </Box>
  );
};

export default TicketsTab;
